import { getMessages } from '../../../../../../../store/constants';

export const TOOLTIP_CLOSE_BOARD = getMessages().getText('recent_panel.boards.close');
export const TOOLTIP_BOARD_OPEN = getMessages().getText('recent_panel.boards.open');
export const TITLE_RECENT = getMessages().getText('recent_panel.boards.title');
export const TITLE_STARRED = getMessages().getText('common.starred');
export const TEXT_STARRED_EMPTY = getMessages().getText('recent_panel.boards.nostarred');
export const TOOLTIP_REMOVE_FROM_STARRED = getMessages().getText('top_bar.board.remove_from_starred');
export const TEXT_STARRED_EMPTY_FIRST = getMessages().getText('recent_panel.boards.nostarred_text_first');
export const TEXT_STARRED_EMPTY_SECOND = getMessages().getText('recent_panel.boards.nostarred_text_second');
